import ApiService from '../apiservice'

export default class AtividadeService extends ApiService {
  constructor() {
    super('/atividades')
  }

  cadastrarAtividade(atividade) {
    return this.post('/',atividade);
  }

  cadastrarAtividadeUsuario(atividadeUsuario) {
    return this.post('/atividadeUsuario',atividadeUsuario);
  }

  atividadesAtrasadasResponsavel(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesAtrasadasResponsavel/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesHojeResponsavel(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesHojeResponsavel/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesSeteResponsavel(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesSeteResponsavel/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesTrintaResponsavel(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesTrintaResponsavel/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesAtrasadasInteressados(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesAtrasadasInteressados/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesHojeInteressados(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesHojeInteressados/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesSeteInteressados(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesSeteInteressados/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  atividadesTrintaInteressados(usuario,pesquisa,importante,urgente,fatal,compromissos,tarefas,publicacoes,classificacao,ordem) {
    return this.get(`/atividadesTrintaInteressados/${usuario}?pesquisa=${pesquisa}&importante=${importante}&urgente=${urgente}&fatal=${fatal}&compromissos=${compromissos}&tarefas=${tarefas}&publicacoes=${publicacoes}&classificacao=${classificacao}&ordem=${ordem}`);
  }

  compromissosAtrasados(usuario,pesquisa) {
    return this.get(`/compromissosAtrasados/${usuario}?pesquisa=${pesquisa}`);
  }

  compromissosHoje(usuario,pesquisa) {
    return this.get(`/compromissosHoje/${usuario}?pesquisa=${pesquisa}`);
  }

  compromissosSete(usuario,pesquisa) {
    return this.get(`/compromissosSete/${usuario}?pesquisa=${pesquisa}`);
  }

  compromissosTrinta(usuario,pesquisa) {
    return this.get(`/compromissosTrinta/${usuario}?pesquisa=${pesquisa}`);
  }

  consultarAtividade(codigo,usuario) {
    return this.get(`/${codigo}/${usuario}`);
  }

  consultarUsuariosAtividade(atividade, tipo) {
    return this.get(`/usuariosAtividade?atividade=${atividade}&tipo=${tipo}`);
  }

  consultarHistorico(atividade) {
    return this.get(`/historico/${atividade}`);
  }

  incluirHistorico(historico) {
    return this.post('/historico',historico);
  }

  excluirHistorico(historico, usuarioCadastrou, usuarioSolicitou) {
    return this.delete(`/historico?historico=${historico}&usuarioCadastrou=${usuarioCadastrou}&usuarioSolicitou=${usuarioSolicitou}`);
  }

  consultarHistoricoPorCodigo(codigo) {
    return this.get(`/consulta-historico-por-codigo/${codigo}`);
  }

  alterarHistorico(historico) {
    return this.put('/alterar-historico',historico);
  }

  alterarAtividade(dataAntiga, statusAntigo, usuario, atividade) {
    return this.put(`/alterarAtividade/${atividade.atividade.codigo}/dataAnterior/${dataAntiga}/statusAnterior/${statusAntigo}/usuario/${usuario}`, atividade);
  }

  consultarAtividadePorProcesso(processo) {
    return this.get(`/porProcesso/${processo}`);
  }

  consultarAtividadesPorProcessoFiltro(filtro) {
    let params = `/porProcessoFiltro/${filtro.processo}?status=${filtro.status}`;
    params = `${params}&dataLimiteInicial=${filtro.dataLimiteInicial}&dataLimiteFinal=${filtro.dataLimiteFinal}`;
    params = `${params}&prazoFatalInicial=${filtro.prazoFatalInicial}&prazoFatalFinal=${filtro.prazoFatalFinal}`;
    params = `${params}&dataConclusaoInicial=${filtro.dataConclusaoInicial}&dataConclusaoFinal=${filtro.dataConclusaoFinal}`;
    params = `${params}&importante=${filtro.importante}&urgente=${filtro.urgente}`;
    params = `${params}&classificacao=${filtro.classificacao}&ordenacao=${filtro.ordenacao}`;
    return this.get(params);
  }

  consultaAtividadesCriadasUsuario(usuario) {
    return this.get(`/atividadesCriadasUsuario/${usuario}`);
  }

  consultaAtividadesUltimosTrintaDias(usuario) {
    return this.get(`/atividadesUltimosTrintaDiasUsuario/${usuario}`);
  }

  consultaAtividadesUltimosTrintaDiasConcluidas(usuario) {
    return this.get(`/atividadesUltimosTrintaDiasConcluidasUsuario/${usuario}`);
  }

  consultaAtividadesUltimosTrintaDiasConcluidasAtrasadas(usuario) {
    return this.get(`/atividadesUltimosTrintaDiasConcluidasAtrasadasUsuario/${usuario}`);
  }

  consultaAtividadesUltimosTrintaDiasConcluidasNoPrazo(usuario) {
    return this.get(`/atividadesUltimosTrintaDiasConcluidasNoPrazoUsuario/${usuario}`);
  }

  consultaPontuacao(responsavel, interesse, agenda) {
    return this.get(`/pontuacao?responsavel=${responsavel}&interesse=${interesse}&agenda=${agenda}`);
  }

  //Kanban
  consultarKanban(filtro) {
    let params = `/kanban?empresa=${filtro.empresa}&grupo=${filtro.grupo}&usuario=${filtro.usuario}&status=${filtro.status}&limite=${filtro.limite}`;
    if(filtro.dataInicial != null && filtro.dataFinal != null) {
      params = `${params}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`;
    }
    return this.get(params);
  }

  consultarKanbanOutros(filtro) {
    let params = `/kanban-outros?empresa=${filtro.empresa}&grupo=${filtro.grupo}&usuario=${filtro.usuario}&status=${filtro.status}&limite=${filtro.limite}`;
    if(filtro.dataInicial != null && filtro.dataFinal != null) {
      params = `${params}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`;
    }
    return this.get(params);
  }

  alterarMassa(alterar) {
    return this.put('/alterarMassa',alterar);
  }

  cadastrarAtividadeAgrupada(atividade) {
    return this.post('/atividadeAgrupada',atividade);
  }

  listarAtividadesPorDataLimite(filtro) {
    let params = `/listaPorDataLimite?empresa=${filtro.empresa}&usuario=${filtro.usuario}`;
    //Data Limite
    params = `${params}&dataLimiteInicial=${filtro.dataLimiteInicial}&dataLimiteFinal=${filtro.dataLimiteFinal}`;
    //Prazo Fatal
    params = `${params}&prazoFatalInicial=${filtro.prazoFatalInicial}&prazoFatalFinal=${filtro.prazoFatalFinal}`;
    //Data de Conclusão
    params = `${params}&dataConclusaoInicial=${filtro.dataConclusaoInicial}&dataConclusaoFinal=${filtro.dataConclusaoFinal}`;
    //Status
    params = `${params}&status=${filtro.status}`;
    //É pŕazo Fatal
    params = `${params}&isPrazoFatal=${filtro.isPrazoFatal}`;
    //É atividade do tipo financeiro
    params = `${params}&isFinanceiro=${filtro.isFinanceiro}`;
    //Atividades Importantes
    params = `${params}&importante=${filtro.importante}`;
    //Atividades Urgentes
    params = `${params}&urgente=${filtro.urgente}`;
    //Tipo de Usuário
    params = `${params}&tipoUsuario=${filtro.tipoUsuario}`;
    //Processo
    params = `${params}&processo=${filtro.processo}`;
    //Data Selecionada
    params = `${params}&data=${filtro.data}`;
    //Partes
    params = `${params}&partes=${filtro.partes}`;
    //Fase Processual
    params = `${params}&fase=${filtro.fase}`;
    //Classificação e Ordenação
    params = `${params}&classificacao=${filtro.classificacao}&ordenacao=${filtro.ordenacao}`;
    return this.get(params);
  }

  consultarAgendaMesUsuario(usuario,mes,ano) {
    return this.get(`/agenda-mes-usuario?usuario=${usuario}&mes=${mes}&ano=${ano}`);
  }

  consultarHistoricoFasesAtividades(filtro) {
    let params = `/consultar-historico-fase-atividade?processo=${filtro.processo}`;
    params = `${params}&fase=${filtro.fase}&status=${filtro.status}`
    params = `${params}&dataLimiteInicial=${filtro.dataLimiteInicial}&dataLimiteFinal=${filtro.dataLimiteFinal}`;
    params = `${params}&dataFatalInicial=${filtro.dataFatalInicial}&dataFatalFinal=${filtro.dataFatalFinal}`;
    params = `${params}&importante=${filtro.importante}&urgente=${filtro.urgente}`;
    params = `${params}&classificacao=${filtro.classificacao}&ordem=${filtro.ordem}&usuario=${filtro.usuario}`;
    return this.get(params);
  }

  graficoFase(processo) {
    return this.get(`/grafico-fase/${processo}`);
  }

  graficoStatus(processo) {
    return this.get(`/grafico-status/${processo}`);
  }

  diasCalendario(mes,ano) {
    return this.get(`/dias-calendario?mes=${mes}&ano=${ano}`);
  }

  consultarAtividadeCustom(atividade,empresa,usuario) {
    return this.get(`/consultar-atividade-custom/${atividade}/${empresa}/${usuario}`);
  }
	
	cadastrarAtividadeRodizio(request) {
		return this.post('/rodizio',request);
	}
}